import consts from '../consts';
import Model from '../models/model';

const {MomentFormat} = consts;
export const model = new Model({
    name: 'HuluInterfaceLogs',
    idProperty: '_id',
    readOnly:true,
    pageSize: 15,
    disableDelete: true,
    disableAdd: true,
    disableExport: false,
    showGridRefreshBtn: true,
    title: 'InterfaceLogs',
    columns: [
        { field: 'ScopeModelId', header: 'ModelId', readOnly: true, width: 150, type:'string' },
        { field: 'ScopeModel', header: 'ScopeModel', readOnly: true, width: 150, type:'string' },
		{ field: 'SerialNumber', header: 'SerialNumberSecond', readOnly: true, width: 150, type:'string' },
        { field: 'Code', header: 'Code', readOnly: true, width: 200, type:'string' },
        {
            field: 'CodeType',
            header: 'CodeType',
			readOnly: true,
            width: 150,
            type:'string',
            lookup: 'CodeType'
        },
        {
            field: 'Message',
            width: 500,
            header: 'Message',
            readOnly: true,
            type:'string'
        },
        {
            field: 'ActiveYN',
            type:'bool',
            header: 'Active',
            readOnly: true,
            width: 150
        },
        {
            field: 'DataSource',
            header: 'DataSource',
            readOnly: true,
            width: 150,
            type:'string',
            lookup: 'DataSource'
        },
        {
            field: 'CreatedOn',
            header: 'CreatedOn',
            type:'date',
            isLocal:true,
            readOnly: true,
            width: 150,
            format: MomentFormat.DateTimeFormatAMPM,
            isNotformfield:true
        },
        {
            field: 'ModifiedOn',
            header: 'ModifiedOn',
            type:'date',
            isLocal:true,
            readOnly: true,
            width: 150,
            format: MomentFormat.DateTimeFormatAMPM,
            isNotformfield:true
        },
    ]
});

export default model.createFormBase();